(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/core/assets/javascripts/numbergames-model.js') >= 0) return;  svs.modules.push('/components/numbergames/core/assets/javascripts/numbergames-model.js');

'use strict';

svs.numbergames.core.NumbergamesModel = Backbone.Model.extend({
  constructor: function () {
    let attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    attrs = _.clone(attrs);

    this.preinitialize.call(this, attrs, options);
    this.cid = _.uniqueId(this.cidPrefix);
    if (options.collection) this.collection = options.collection;
    if (typeof this.defaults === 'function') {
      this.attributes = this.defaults.call(this);
      this.validateDefaults = this.defaults.call(this);
    } else {
      this.attributes = _.clone(this.defaults || {});
      this.validateDefaults = _.clone(this.defaults || {});
    }
    if (options.parse && !options.parseCollection) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults(_.extend({}, this.attributes, attrs), this.attributes);
    this.set(attrs, options);
    this.changed = {};
    this.initialize.call(this, attrs, options);
  },
  _validate(attrs, options) {
    const defaults = this.validateDefaults,
      defaultKeyArray = Object.keys(defaults),
      attrKeyArray = Object.keys(attrs);
    for (let i = 0; i < attrKeyArray.length; i++) {
      const attrKey = attrKeyArray[i];
      if (defaultKeyArray.indexOf(attrKey) < 0) {
        svs.numbergames.core.logger.debug("Key '".concat(attrKey, "' not found in defaults. REMOVED"));
        delete attrs[attrKey];
      } else if (typeof defaults[attrKey] !== 'undefined' && typeof attrs[attrKey] !== 'undefined' && typeof attrs[attrKey] !== typeof defaults[attrKey]) {
        let type = typeof defaults[attrKey];
        if (type === 'object') {
          if (Array.isArray(defaults[attrKey])) {
            type = 'array';
          } else if (defaults[attrKey] instanceof Backbone.Model) {
            type = 'Backbone.Model';
          } else if (defaults[attrKey] instanceof Backbone.Collection) {
            type = 'Backbone.Collection';
          } else if (svs.numbergames.utils && svs.numbergames.utils.NumberList && defaults[attrKey] instanceof svs.numbergames.utils.NumberList) {
            type = 'svs.numbergames.utils.NumberList';
          }
        }
        svs.numbergames.core.logger.debug("'".concat(attrKey, "' should be type '").concat(type, "'. REMOVED"));
        delete attrs[attrKey];
      }
    }
    if (!options.validate || !this.validate) return true;
    attrs = _.extend({}, this.attributes, attrs);
    const error = this.validationError = this.validate(attrs, options) || null;
    if (!error) return true;
    this.trigger('invalid', this, error, _.extend(options, {
      validationError: error
    }));
    return false;
  },
  update(attrs, options) {
    svs.numbergames.core.logger.debug('NumbergamesModel update', attrs, options);
    if (options.parse) {
      attrs = this.parse(attrs, options);
    }
    if (options.idAttribute && this.isNew()) {
      this.idAttribute = options.idAttribute;
    }
    return this.set(attrs, options);
  },
  fetch(options) {
    svs.numbergames.core.logger.debug('NumbergamesModel fetch', options);
    options = _.extend({
      parse: true
    }, options);
    const model = this,
      success = options.success,
      error = options.error;
    options.success = function (resp) {
      resp = model.parseRawResponse(resp);
      svs.ui.loader.hide();
      if (!model.update(resp, options)) return false;
      if (success) success.call(options.context, model, resp, options);
      model.trigger('sync', model, resp, options);
    };
    options.error = function (resp) {
      svs.ui.loader.hide();
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
    svs.ui.loader.show();
    return this.sync('read', this, options);
  },
  parseRawResponse(resp) {
    return resp;
  },
  toObject() {
    let model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
    if (!(model instanceof Backbone.Model)) {
      return model;
    }
    const attributes = {};
    const attributeKeys = Object.keys(model.attributes);
    for (let i = 0, len = attributeKeys.length; i < len; i++) {
      const key = attributeKeys[i];
      const value = model.get(key);
      if (value !== undefined) {
        if (value instanceof Backbone.Model) {
          if (typeof value.toObject === 'function') {
            attributes[key] = value.toObject();
          } else {
            attributes[key] = this.toObject(value);
          }
        } else if (value instanceof Backbone.Collection) {
          attributes[key] = value.toArray();
        } else {
          attributes[key] = value;
        }
      }
    }
    return attributes;
  },
  destroy(options) {
    this.stopListening();
    this.trigger('destroy', this, this.collection, options);
  }
});

 })(window);